import { ReactNode } from 'react'
import { Spinner } from '@/common/ui/spinner'

type SearchResultsStateProps<T> = {
    searching: boolean
    items: T[]
    emptyMessage: string
    children: (items: T[]) => ReactNode
}

export function SearchResultsState<T>({ searching, items, emptyMessage, children }: SearchResultsStateProps<T>) {
    if (searching) {
        return <Spinner size="medium" className="m-auto" />
    }

    if (items.length === 0) {
        return <p className="text-content-secondary p-2 text-sm">{emptyMessage}</p>
    }

    return <>{children(items)}</>
}
